import React from "react"
import {FaLinkedin, FaGithub} from "react-icons/fa"
import {FiMail} from "react-icons/fi"
import { profile } from "../../data/profile"


const HeaderSocial = () => {
    return(
        <div className='header__social'>
            <a href={profile.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedin/></a>
            <a href={profile.github} target="_blank" rel="noreferrer" aria-label="GitHub"><FaGithub/></a>
            <a href={`mailto:${profile.email}`} aria-label="Email"><FiMail/></a>
        </div>
    )
}

export default HeaderSocial
